var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('loading-spinner-cover'),_vm._t("topBar"),_c('b-container',{staticClass:"px-lg-5 h-100",attrs:{"fluid":""}},[_c('b-row',{staticClass:"h-100"},[_vm._t("default")],2)],1)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }